export const VEHICLE_TYPE_ASSET = 'Asset'
export const VEHICLE_TYPE_TRADE_IN = 'Trade In'

export const VEHICLE_USE_BUSINESS = 'Business'
export const VEHICLE_USE_PERSONAL = 'Personal'
